import { useState, useCallback } from 'react';

export type PropertyFormTabId = 'general' | 'details' | 'criteria' | 'description' | 'photos' | 'documents' | 'matching';

export const usePropertyFormTabs = () => {
  const [activeTab, setActiveTab] = useState<PropertyFormTabId>('general');

  const goToNextTab = useCallback(() => {
    const tabOrder: PropertyFormTabId[] = [
      'general',
      'details', 
      'criteria',
      'description',
      'photos',
      'documents',
      'matching'
    ];
    const currentIndex = tabOrder.indexOf(activeTab);
    if (currentIndex < tabOrder.length - 1) {
      setActiveTab(tabOrder[currentIndex + 1]);
    }
  }, [activeTab]);

  return {
    activeTab,
    setActiveTab,
    goToNextTab
  };
};